var go = require('gojs');

var MAX_SAFE_GEOMETRY_DIMENSION = 1000000;

function isFiniteNumber(value) {
  return Number.isFinite(Number(value));
}

function isSafeGeometryBounds(bounds) {
  if (!bounds) return false;

  var x = Number(bounds.x);
  var y = Number(bounds.y);
  var width = Number(bounds.width);
  var height = Number(bounds.height);
  var right = x + width;
  var bottom = y + height;

  if (![x, y, width, height, right, bottom].every(isFiniteNumber)) {
    return false;
  }

  return [x, y, width, height, right, bottom].every(function(value) {
    return Math.abs(value) <= MAX_SAFE_GEOMETRY_DIMENSION;
  });
}

function readSafeGeometryBounds(geometry) {
  if (!geometry) return null;

  try {
    var bounds = geometry.bounds;
    return isSafeGeometryBounds(bounds) ? bounds : null;
  } catch (err) {
    return null;
  }
}

function applySvgFillRule(geometry, element) {
  if (!geometry || !element || typeof element.getAttribute !== 'function') return;

  var fillRule = element.getAttribute('fill-rule') || element.getAttribute('fillRule');
  if (!fillRule) return;

  var normalizedRule = fillRule.toLowerCase();
  if (normalizedRule === 'evenodd' && go.Geometry.FillRuleEvenOdd !== undefined) {
    geometry.fillRule = go.Geometry.FillRuleEvenOdd;
  } else if (normalizedRule === 'nonzero' && go.Geometry.FillRuleNonZero !== undefined) {
    geometry.fillRule = go.Geometry.FillRuleNonZero;
  }
}

function warnSkippedPath(context, err) {
  if (typeof console === 'undefined' || !console || typeof console.warn !== 'function') return;

  var message = context
    ? '[' + context + '] Skipping SVG path GoJS could not safely parse.'
    : 'Skipping SVG path GoJS could not safely parse.';
  console.warn(message, err);
}

function parseSvgPathGeometry(pathData, options) {
  var data = typeof pathData === 'string' ? pathData.trim() : '';
  if (!data) return null;

  options = options || {};

  try {
    var geometry = go.Geometry.parse(data, true);
    if (!readSafeGeometryBounds(geometry)) {
      if (!options.silent) warnSkippedPath(options.context || 'svgGeometry');
      return null;
    }
    applySvgFillRule(geometry, options.element);
    return geometry;
  } catch (err) {
    if (!options.silent) warnSkippedPath(options.context || 'svgGeometry', err);
    return null;
  }
}

module.exports = {
  parseSvgPathGeometry: parseSvgPathGeometry,
  readSafeGeometryBounds: readSafeGeometryBounds,
  isSafeGeometryBounds: isSafeGeometryBounds,
  applySvgFillRule: applySvgFillRule
};
